import { NavLink, useNavigate } from "react-router-dom";
import { Globe, LayoutDashboard, UserRound, Ticket, Users, LogOut, Share2, ShieldAlert, ShoppingCart, Crown, Cpu, Send, Mail, Zap } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/contexts/AuthContext";

const NAV = [
  { to: "/dashboard", label: "Kontrolna tabla", icon: LayoutDashboard, id: "nav-dashboard" },
  { to: "https://www.myner-adria.com/tonini-bitlab", label: "Tonini BitLab - prezentacija", icon: Zap, id: "nav-tonini", external: true },
  { to: "/profil", label: "Moj profil", icon: UserRound, id: "nav-profile" },
  { to: "/kupi-tikete", label: "Kupi tikete", icon: ShoppingCart, id: "nav-buy" },
  { to: "/ciklusi", label: "Ciklusi mašina", icon: Cpu, id: "nav-cycles" },
  { to: "/pozovi", label: "Pozovi prijatelje", icon: Share2, id: "nav-invite" },
  { to: "/promoteri", label: "Najbolji promoteri", icon: Crown, id: "nav-leaderboard" },
  { to: "https://t.me/wemynetoghether", label: "Telegram kanal", icon: Send, id: "nav-telegram", external: true },
  { to: "https://docs.google.com/forms/d/e/1FAIpQLScX-7XfmdgtdRjxtdjltvkNLH1kXwZxIA47UECoAv0r-wxGqw/viewform?usp=send_form", label: "Kontaktirajte nas", icon: Mail, id: "nav-contact", external: true },
  { to: "https://www.nasha-hub.com", label: "NAŠA HUB Community", icon: Globe, id: "nav-hub", external: true },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/prijava");
  };

  const items = [...NAV];
  if (user?.role === "admin") {
    items.push({ to: "/admin", label: "Admin panel", icon: ShieldAlert, id: "nav-admin" });
  }

  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex w-64 shrink-0 flex-col border-r border-white/10 bg-[#050505] sticky top-0 h-screen"
    >
      <div className="px-5 py-5 border-b border-white/10">
        <Logo size={52} withText />
      </div>

      <nav className="flex-1 px-3 py-6 space-y-1">
        {items.map((item) => (
          item.external ? (
            <a
              key={item.to}
              href={item.to}
              data-testid={item.id}
              className="group flex items-center gap-3 px-4 py-3 text-sm uppercase tracking-wider transition-all duration-200 border-l-2 border-[#22ff77]/40 text-[#22ff77] hover:text-white hover:border-[#22ff77]"
            >
              <item.icon className="w-4 h-4" strokeWidth={1.5} />
              <span className="font-display font-semibold">{item.label}</span>
            </a>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.id}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-4 py-3 text-sm uppercase tracking-wider transition-all duration-200 border-l-2 ${
                  isActive
                    ? "border-[#22ff77] bg-[#22ff77]/5 text-[#22ff77]"
                    : "border-transparent text-zinc-400 hover:text-white hover:border-white/30"
                }`
              }
            >
              <item.icon className="w-4 h-4" strokeWidth={1.5} />
              <span className="font-display font-semibold">{item.label}</span>
            </NavLink>
          )
        ))}
      </nav>

      <div className="p-4 border-t border-white/10">
        <div className="mb-3 px-2">
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Prijavljen kao</div>
          <div className="text-sm text-white truncate" data-testid="sidebar-user-name">
            {user?.name || user?.email}
          </div>
        </div>
        <button
          data-testid="logout-button"
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 py-2.5 border border-[#ff7a18]/40 text-[#ff7a18] hover:bg-[#ff7a18]/10 transition-all rounded-sm text-xs uppercase tracking-widest font-display font-semibold"
        >
          <LogOut className="w-4 h-4" strokeWidth={1.5} />
          Odjavi se
        </button>
      </div>
    </aside>
  );
}
